import mutations from './mutations';
import {notification} from "ant-design-vue";
import {DataService} from "../../../config/dataService/dataService";

const addNotificationError = (err) => {
    notification.error({
        message: err,
    });
};

const state = () => ({
    flows: [],
    loadingFlows: false,
    errorFlows: null,
});

const actions = {
    /**
     *
     * Get flows
     *
     * @param commit
     * @param id
     * @returns {Promise<void>}
     */
    async getFlows({commit}) {
        try {
            await commit('flowsDataBegin');
            const response = await DataService.get(`/offerflow/allowedflows`);
            await commit('flowsDataSuccess', response.data);
        } catch (err) {
            await commit('flowsDataErr', err);
            addNotificationError(err?.response?.data?.message);
        }
    },
    async cleanFlows({commit}) {
        await commit('cleanFlows');
    },
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
};
